/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface TwoDWaterLevel
 */
export interface TwoDWaterLevel {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  value: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the TwoDWaterLevel interface.
 */
export function instanceOfTwoDWaterLevel(value: object): value is TwoDWaterLevel {
  if (!("value" in value) || value["value"] === undefined) return false;
  return true;
}

export function TwoDWaterLevelFromJSON(json: any): TwoDWaterLevel {
  return TwoDWaterLevelFromJSONTyped(json, false);
}

export function TwoDWaterLevelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TwoDWaterLevel {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    value: json["value"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function TwoDWaterLevelToJSON(json: any): TwoDWaterLevel {
  return TwoDWaterLevelToJSONTyped(json, false);
}

export function TwoDWaterLevelToJSONTyped(
  value?: Omit<TwoDWaterLevel, "url" | "simulation" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    value: value["value"],
  };
}
